export const profileOperationAdapter = profileOperation => ({
  id: profileOperation.id,
  name: profileOperation.name,
  description: profileOperation.description,
  createdAr: profileOperation.created_at,
  updatedAt: profileOperation.updated_at,
  command: profileOperation.command,
  status: profileOperation.status
})
